{
  "rwg-cancel-request-page": {
    "buttons": {
      "cancel": "Annuler",
      "submit": "Soumettre",
      "to-home-page": "Vers la page d'accueil"
    },
    "meta": {
      "title": "Beauty Pro - Demande de désactivation de l'intégration Google",
      "description": "Remplissez le formulaire suivant pour demander la désactivation de notre intégration sur votre carte Google."
    },
    "text": {
      "title": "Demande de désactivation de l'intégration Google",
      "subtitle-salon-info": "Où se trouve votre salon ?",
      "subtitle-owner-info": "Comment pouvons-nous vous contacter ?",
      "email": "Votre email",
      "full-name": "Votre nom complet",
      "language": "Votre langue de communication préférée",
      "request-sent-success": "Votre demande a été envoyée avec succès !",
      "request-confirmation-sent-to-your-email": "Notre confirmation sera envoyée à votre e-mail. Veuillez également vérifier votre dossier spam !",
      "salon-address": "L'adresse de votre salon",
      "salon-name": "Le nom de votre salon",
      "we-will-contact-soon": "Notre équipe est impatiente de vous aider et nous prendrons contact avec vous dans les plus brefs délais pour répondre à votre demande."
    }
  }
}
